(function () {
    'use strict';

    angular.module("imApp").factory("subtaskSelectService", ['$ihttp', function ($ihttp) {
        let service = {
            listSubTasks: function (parms) {
                return $ihttp.post({
                    method: 361,
                    parameters: parms || {}
                });
            },
            addItems: function (mergeObj) {
                return $ihttp.post({
                    method: 362,
                    parameters: mergeObj
                });
            }
        };

        return service;
    }]);
})();
